<template>
  <div>

    <!--		<button class="spinBtn">CLICK TO SPIN!</button>-->


    <div class="wheelContainer">
      <svg class="wheelSVG" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        text-rendering="optimizeSpeed" preserveAspectRatio="xMidYMin meet">
        <defs>
          <filter id="shadow" x="-100%" y="-100%" width="550%" height="550%">
            <feOffset in="SourceAlpha" dx="0" dy="0" result="offsetOut"></feOffset>
            <feGaussianBlur stdDeviation="9" in="offsetOut" result="drop" />
            <feColorMatrix in="drop" result="color-out" type="matrix" values="0 0 0 0   0
              0 0 0 0   0
              0 0 0 0   0
              0 0 0 .3 0" />
            <feBlend in="SourceGraphic" in2="color-out" mode="normal" />
          </filter>
        </defs>
        <g class="mainContainer">
          <g class="wheel">
          </g>
        </g>
        <g class="centerCircle" />
        <g class="wheelOutline" />
        <g class="pegContainer" opacity="1">
          <path class="peg" :fill="pegColor"
            d="M22.139,0C5.623,0-1.523,15.572,0.269,27.037c3.392,21.707,21.87,42.232,21.87,42.232 s18.478-20.525,21.87-42.232C45.801,15.572,38.623,0,22.139,0z" />
        </g>
        <g class="valueContainer" />
      </svg>
      <div class="toast">
        <p></p>
      </div>
    </div>

  </div>
</template>

<script>

import Spin2WinWheel from './Spin2WinWheel_updated';

export default {
  name: 'Wheel',

  props: {
    spinButtonText: String,
    spinButtonTextColor: String,
    spinButtonBackgroundColor: String,
    spinButtonFontFamily: String,
    spinButtonFontSize: String,
    segmentsFontFamily: String,
    segmentsFontSize: Number,
    segmentsStrokeWidth: Number,
    segmentsStrokeColor: String,
    spinItems: Array,
    id: String,
    isDemo: Boolean,
    inFrame: Boolean,
    centerImageUrl: String,
    centerBackgroundColor: String,
    centerCircleSize: Number,
    centerCircleStrokeColor: String,
    centerCircleStrokeWidth: Number,
    wheelStrokeColor: String,
    wheelStrokeWidth: Number,
    wheelTextColor: String,
    pegBackgroundColor: String,
    segmentsImageSize: Number,
    segmentsImageOffset: Number
  },

  data() {
    return {

      pegColor: '#EEEEEE',


      // wheelWidth: 0,
      // wheelHeight: 0,
      //
      // padding: 15
    };
  },

  methods: {
    onComplete: function (event) {
      this.$emit('onComplete');
    },
    onStart: function (event) {
      this.$emit('onStart');
    },

  },


  mounted() {

    // var mySpinBtn = document.querySelector('.spinBtn');
    var myWheel = new Spin2WinWheel();

    if (this.pegBackgroundColor)
      this.pegColor = this.pegBackgroundColor;

    let centerCircleFillColor = "#EDEDED";
    if (this.centerBackgroundColor)
      centerCircleFillColor = this.centerBackgroundColor;

    let centerImageUrl = null;
    if (this.centerImageUrl)
      centerImageUrl = this.centerImageUrl;

    let centerCircleSize = 300;
    if (this.centerCircleSize)
      centerCircleSize = this.centerCircleSize;

    let centerCircleStrokeColor = "#F1DC15";
    if (this.centerCircleStrokeColor)
      centerCircleStrokeColor = this.centerCircleStrokeColor;

    let centerCircleStrokeWidth = 12;
    if (this.centerCircleStrokeWidth)
      centerCircleStrokeWidth = this.centerCircleStrokeWidth;

    let wheelStrokeColor = "#D0BD0C";
    if (this.wheelStrokeColor)
      wheelStrokeColor = this.wheelStrokeColor;

    let wheelStrokeWidth = 18;
    if (this.wheelStrokeWidth)
      wheelStrokeWidth = this.wheelStrokeWidth;

    let wheelTextColor = "#EDEDED";
    if (this.wheelTextColor)
      wheelTextColor = this.wheelTextColor;

    let segmentsStrokeWidth = 4;
    if (this.segmentsStrokeWidth)
      segmentsStrokeWidth = this.segmentsStrokeWidth;

    let segmentsStrokeColor = "#E2E2E2";
    if (this.segmentsStrokeColor)
      segmentsStrokeColor = this.segmentsStrokeColor;

    let segmentsImageSize = 220;
    if (this.segmentsImageSize) {
      segmentsImageSize = segmentsImageSize / 100 * this.segmentsImageSize;
    }

    let segmentsImageOffset = 50;
    if (this.segmentsImageOffset) {
      segmentsImageOffset = segmentsImageOffset + this.segmentsImageOffset;
    }

    var jsonData = {
      "isDemo": this.isDemo,
      "inFrame": this.inFrame,
      "colorArray": ["#364C62", "#F1C40F", "#E67E22", "#E74C3C", "#95A5A6", "#16A085", "#27AE60", "#2980B9", "#8E44AD", "#2C3E50", "#F39C12", "#D35400", "#C0392B", "#BDC3C7", "#1ABC9C", "#2ECC71", "#E87AC2", "#3498DB", "#9B59B6", "#7F8C8D"],
      "textColorArray": ["#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED", "#EDEDED"],

      "spinDirection": "ccw",
      "svgWidth": 1200,
      "svgHeight": 900,
      "wheelStrokeColor": wheelStrokeColor,
      "wheelStrokeWidth": wheelStrokeWidth,
      "wheelSize": 1100,
      "wheelTextOffsetY": 175,
      "wheelTextColor": wheelTextColor,
      "wheelImageOffsetY": segmentsImageOffset,
      "wheelImageSize": segmentsImageSize,
      "centerCircleSize": centerCircleSize,
      "centerCircleStrokeColor": centerCircleStrokeColor,
      "centerCircleStrokeWidth": centerCircleStrokeWidth,
      "centerCircleFillColor": centerCircleFillColor,
      "centerCircleImage": centerImageUrl,
      "centerCircleImageOffsetY": 120,
      "segmentStrokeColor": segmentsStrokeColor,
      "segmentStrokeWidth": segmentsStrokeWidth,
      "centerX": 600,
      "centerY": 450,
      "hasShadows": true,
      "numSpins": 1,
      "minSpinDuration": 3,
      "gameOverText": "",
      "invalidSpinText": "INVALID SPIN. PLEASE SPIN AGAIN.",
      "introText": this.spinButtonText,
      "spinButtonTextColor": this.spinButtonTextColor,
      "spinButtonFontFamily": this.spinButtonFontFamily,
      "spinButtonFontSize": this.spinButtonFontSize,
      "spinButtonBackgroundColor": this.spinButtonBackgroundColor,
      "segmentsFontFamily": this.segmentsFontFamily,
      "segmentsFontSize": this.segmentsFontSize,
      "hasSound": false,
      "gameId": this.id,
      "clickToSpin": true
    };

    jsonData.segmentValuesArray = [];
    jsonData.spinDestinationArray = [];
    var itemCount = 0;
    this.spinItems.forEach(function (element) {
      itemCount++;
      if (element.text) {
        jsonData.segmentValuesArray.push(
          {
            "type": "string",
            "value": element.text.toUpperCase(),
            "win": element.win
          }
        );
      } else if (element.imageUrl) {
        jsonData.segmentValuesArray.push(
          {
            "type": "image",
            "value": element.imageUrl,
            "win": element.win
          }
        );
      }

      if (element.color) {
        jsonData.colorArray[itemCount - 1] = element.color;
      }

      if (element.textColor) {
        jsonData.textColorArray[itemCount - 1] = element.textColor;
      }
      else {
        jsonData.textColorArray[itemCount - 1] = wheelTextColor;
      }


      if (element.target) {
        jsonData.spinDestinationArray.push(itemCount);
      }
    });


    myWheel.init({
      data: jsonData,
      onResult: this.onComplete,
      onGameEnd: null,
      onError: null,
      onSpin: this.onStart
    });

  },
};


</script>


<style scoped>
.peg,
.wheelSVG {
  visibility: hidden;
}

.wheelContainer,
body,
html {
  width: 100%;
  height: 325px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0;
}

.centerCircle,
.valueContainer,
.wheelOutline,
.wheelText {
  pointer-events: none;
}

.toast,
.wheelContainer,
body,
html {
  text-align: center;
}

.wheelContainer,
button {
  transform: translate(-50%, 0);
}

.toast,
button {
  position: absolute;
  background-color: #E81D62;
}

body {
  background-color: #2d2d2d;
  overflow: hidden;
}

body,
html {
  margin: 0;
  padding: 0;
}

.wheelContainer {

  /*padding-top: 150px;*/

  position: absolute;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  left: 50%;

  text-anchor: middle;
  font-family: 'Fjalla One', Arial, sans-serif;
  -webkit-user-select: none;
  user-select: none;

}

.wheelSVG {
  position: absolute;
  overflow: visible;
  width: 100%;
  height: auto;
}

.wheelText {
  text-anchor: middle;
  font-family: 'Fjalla One', Arial, sans-serif;
  -webkit-user-select: none;
  user-select: none;
}

.toast {
  border-radius: 12px;
  opacity: 0;
}

.toast p {
  clear: both;
  font-family: 'Fjalla One', Arial, sand-serif;
  margin: 23px;
  font-size: 20px;
  color: #ededed;
  letter-spacing: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 32px;
  -webkit-transition: line-height .2s ease;
  transition: line-height .2s ease;
}

button {
  left: 50%;
  width: 80%;
  top: 10px;
  max-width: 400px;
  padding: 8px;
  font-weight: 700;
  font-size: 16px;
  color: #ededed;
  border-radius: 6px;
  border: none;
  box-shadow: 0 2px 0 #D71559;
  cursor: pointer;
  font-family: "Fjalla One", Helvetica, Arial, sans-serif;
}

@media only screen and (max-width: 480px) {

  .toast p,
  .toast span {
    font-size: 18px;
    line-height: 18px;
  }
}

/* @media only screen and (min-width: 481px) and (max-width: 800px) {

  .toast p,
  .toast span {
    font-size: 38px;
    line-height: 38px;
  }
}

@media only screen and (min-width: 801px) {

  .toast p,
  .toast span {
    font-size: 58px;
    line-height: 60px;
  }
} */

/* @media only screen and (max-height: 480px) {

  .toast p,
  .toast span {
    font-size: 33px;
    line-height: 35px;
  }

  button {
    font-size: 22px;
    padding: 10px;
    width: 40%;
  }

  .wheelContainer {
    top: 70px;
  }
} */

button:focus {
  outline: 0;
}
</style>